import React from "react"
import { FormikTextField } from "../../../../../../../shared/components/forms/Formik"
import { PublicInstitutionDetailsFormValues } from "../../billReceiversTypes"
import { DetailsAddressFormSection } from "./DetailsAddressFormSection"
import { DetailsContactFormSection } from "./DetailsContactFormSection"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"

type PrivatePersonProps = Readonly<{
    isMerchantAdmin: boolean
}>

export function PublicInstitutionForm({ isMerchantAdmin }: PrivatePersonProps) {
    return (
        <>
            {isMerchantAdmin && (
                <LocalizedStrict
                    id="bill-receivers-form-label-debtor-number"
                    attrs={{ label: true, placeholder: true }}
                >
                    <FormikTextField<PublicInstitutionDetailsFormValues>
                        name="debtorNumber"
                        label="Debtor number"
                        placeholder="Identifier of debtor in your accounting system"
                        fullWidth
                    />
                </LocalizedStrict>
            )}
            <LocalizedStrict id="bill-receivers-form-label-institution-name" attrs={{ label: true }}>
                <FormikTextField<PublicInstitutionDetailsFormValues>
                    name="institutionName"
                    label="Institution name (*)"
                    fullWidth
                />
            </LocalizedStrict>
            <DetailsAddressFormSection />
            <DetailsContactFormSection />
        </>
    )
}
